/* RESPONSIBLE TEAM: team-proactive-support */
import RulesetLinkSerializer from '../ruleset-link';

export default RulesetLinkSerializer;
